const SIGNUP_INTENT_KEY = "ticketwhats.publicSignup";

export function getSignupIntent() {
  try {
    const raw = sessionStorage.getItem(SIGNUP_INTENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setSignupIntent(intent) {
  try {
    sessionStorage.setItem(SIGNUP_INTENT_KEY, JSON.stringify({
      planPublicId: intent.planPublicId || null,
      planName: intent.planName || null,
      amountCents: intent.amountCents || null,
      currency: intent.currency || null,
      billingCycle: intent.billingCycle || null,
      users: intent.users || null,
      connections: intent.connections || null,
    }));
  } catch {
    // silencioso
  }
}

export function clearSignupIntent() {
  try {
    sessionStorage.removeItem(SIGNUP_INTENT_KEY);
  } catch {
    // silencioso
  }
}